import script from "./ActivityScoresPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityScoresPanel.vue?vue&type=script&setup=true&lang=js"

import "./ActivityScoresPanel.vue?vue&type=style&index=0&id=07535164&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07535164"]])

export default __exports__